import * as md5 from "md5";

const createKey = (text, length = 8) => {
    return md5(text).substr(0, length)
};

export { createKey };
